import { createTheme } from "@mui/material/styles"

export default createTheme({
  components: {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none",
          KhtmlUserSelect: "none",
          MozUserSelect: "none",
          MsUserSelect: "none",
          userSelect: "none",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#181818",
      contrastText: "#E6E2B1",
    },
  },
})
